import DevToolsNavbar from 'components/organisms/dev-tools-navbar/DevToolsNavbar';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { environment } from 'services/environment/Environment';
import './DevToolsTemplate.scss';

const DevToolsTemplate = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (environment().node.nodeEnv !== 'development') navigate('/');
  }, [environment().node.nodeEnv]);

  return (
    <div className='dev-tools-template'>
      <div className='navbar'>
        <DevToolsNavbar />
      </div>
      <div className='dev-tools'>
        <Outlet />
      </div>
    </div>
  );
};

export default DevToolsTemplate;
